// Слотов в группе PUBG не больше сотни, а PUBG ID — длинные числа,
// поэтому короткое число в поиске считаем номером слота
const SLOT_QUERY = /^\d{1,3}$/

/**
 * Команды группы PUBG, стоящие на слоте из поиска.
 *
 * Слот ищется точным числом: «5» найдёт слот 5, но не 15. Если в поиске
 * не номер слота или такого слота ни у кого нет, возвращается null —
 * тогда работает обычный поиск по названию, нику и PUBG ID. Иначе «5»
 * совпадало бы с половиной PUBG ID в группе и слот было бы не найти.
 *
 * Слот 0 — «слот не назначен», по нему не ищем.
 *
 * @param {Object[]} groupTeams — teamsByGroup (с group_result.slot_number)
 * @param {string} query — строка из поиска
 * @returns {Object[]|null}
 */
export const findTeamsBySlot = (groupTeams, query) => {
    const normalizedQuery = String(query || '').trim()
    if (!SLOT_QUERY.test(normalizedQuery)) return null

    const slot = Number(normalizedQuery)
    if (!slot) return null

    const found = (groupTeams || []).filter((groupTeam) => Number(groupTeam?.group_result?.slot_number) === slot)
    return found.length ? found : null
}
